import { isPWAiOS } from "utils/detectDevice";

export const DEFAULT = "/";
export const ANY_OTHER = "*";

export const LOGIN = "/login";
export const JOIN = "/join";
export const RESET_PASSWORD = "/reset-password";

export const FORECAST = "/forecast";
export const RECORDS = "/records";
export const STATISTICS = "/statistics";
export const NOTIFICATIONS = "/notifications";
export const PRICES = "/prices";
export const EARNINGS = "/earnings";
export const RELAY = "/relay";
export const INVERTER = "/inverter";

export const BOTTOM_NAV_HEIGHT = isPWAiOS() ? 84 : 56;
